import {serialize} from 'object-to-formdata';

import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const postBecomeCreatorData = (medicalIdFile, medicalId) => {
  const formData = serialize({
    doctor_profile: {
      ...(medicalIdFile ? {medical_identificator_file: medicalIdFile} : {}),
      medical_identificator: medicalId,
    },
  });

  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.POST,
    path: `/api/v1/profiles/become_content_creator_requests`,
    formData: formData,
  });
};

export default postBecomeCreatorData;
